import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { hrefFor } from '../../routers';
import { tc } from '../../lib/trackingContext';
import { PaymentMethod } from '../usePaymentMethods';
import { useCartItems } from '../useCart';
import { CheckoutStep } from './useCheckoutStepTracking';

export const usePaymentInfoEnteredTracking = () => {
  const { pathname } = useLocation();
  const { cartItems } = useCartItems();
  const isCheckoutPage = pathname === hrefFor.CheckoutPage();

  const trackPaymentInfoEntered = useCallback(
    (payment?: PaymentMethod) => {
      if (isCheckoutPage && cartItems != null) {
        tc.track('Payment Info Entered', {
          addToScopeOnce: {
            checkoutStep: CheckoutStep.PaymentMethod,
            products: cartItems,
            payment
          },
          addToTrackingEvent: { label: payment?.attributes.source ?? '' }
        });
      } else {
        tc.track('Payment Info Entered');
      }
    },
    [isCheckoutPage, cartItems]
  );

  return { trackPaymentInfoEntered };
};
